import {
  I18N_SUBMIT_CONFIRMATION_BUTTON_KEY,
  I18N_SUBMIT_DISCLAIMER_KEY,
  I18N_WARNINGS_CHECK_LABEL_KEY
} from 'lf-at-theme';

/**
 * App i18n object for the pt-PT locale.
 */

export const appI18NPtPT: Record<string, any> = {
  '*': {
    saveFileName: 'oss-registo-extra-uniao',
    [I18N_SUBMIT_DISCLAIMER_KEY]: 'Está prestes a enviar um registro no regime Extra-União. Ao fazê-lo irá confirmar que não está estabelecido na União Europeia e que as informações fornecidas neste formulário são verdadeiras, completas e precisas.',
    [I18N_SUBMIT_CONFIRMATION_BUTTON_KEY]: 'Submeter',
    [I18N_WARNINGS_CHECK_LABEL_KEY]: 'Confirmo que tomei conhecimento dos alertas produzidos pelos dados desta declaração.',

    ["modalYesBtn"]: 'Confirmar',
    ["modalNoBtn"]: 'Cancelar',

    ["schemeConditionsTitle"]: 'Condições de acesso',
    ["schemeConditions"]: `
      <p>Para se registar neste regime deverá confirmar que reúne as seguintes condições:</p>
      <ul>
        <li>É um <strong>sujeito passivo não estabelecido na UE</strong> que efetua prestações de serviços a consumidores finais e cujo local de tributação das mesmas se situa na UE.</li>
      </ul>
    `,

  }
};
